import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Activity, Event } from "../../models/activity";
import { Button } from "../ui/Button/Button";
import { Typography } from "../ui/Typography/Typography";
import { IconTypes } from "../ui/icons";
import { Icon } from "../ui/icons/Icon";
import { ActionPlanEvent } from "./ActionPlanEvent";
import { ActivityHeader } from "./ActivityHeader";
import "./ActionPlanActivity.scss";

interface ActivityAccordionProps {
  activity: Activity;
  title: string;
  description?: string;
  onDateChange: (clientId: string, eventIndex: number, newDate: Date) => void;
  getEventDescription?: (event: Event) => string | undefined;
  getEventInfo?: (event: Event) => string | undefined;
  error?: string;
}

export const ActivityAccordion = ({
  activity,
  title,
  description,
  onDateChange,
  getEventDescription,
  getEventInfo,
  error,
}: ActivityAccordionProps) => {
  return (
    <Accordion
      className="ActivityAccordion"
      data-testid={`${activity.label}-accordion`}
    >
      <AccordionSummary
        className="ActivityAccordion__summary"
        expandIcon={
          <Button icon color="secondary">
            <Icon type={IconTypes.NavArrow} />
          </Button>
        }
        data-testid={`${activity.label}-accordion-summary`}
      >
        <ActivityHeader title={title} description={description} />
      </AccordionSummary>

      <AccordionDetails>
        <div className="ActivityAccordion__events">
          {activity.events.map((event: Event, eventIndex: number) => (
            <ActionPlanEvent
              key={event.id || eventIndex}
              event={event}
              description={getEventDescription?.(event)}
              info={getEventInfo?.(event)}
              onDateChange={(newDate) =>
                onDateChange(activity.clientId, eventIndex, newDate)
              }
            />
          ))}
          {error && (
            <Typography desktop="body2" color="error">
              {error}
            </Typography>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
